<template>
  <div>
    <div class="d-flex align-items-center pd-10">
      <div class="pd-r-10">Хайх</div>
      <input v-model="srchVal" class="form-control" />
      <div class="btn-group pd-l-10">
        <button @click="doFilter()" class="btn btn-primary">Хайх</button>
        <button
          @click="
            list = listAll;
            srchVal = '';
          "
          class="btn btn-warning"
        >
          Бүгд
        </button>
      </div>
    </div>
    <table class="table table-bordered table-striped table-sm">
      <thead>
        <tr>
          <th>Д/д</th>
          <th>Логин</th>
          <th>Нэр</th>
          <th>Ирц</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in list" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ l.userName }}</td>
          <td>{{ l.displayName }}</td>
          <td>
            <Select
              size="mini"
              @change="i1Changed(l.userId, $event)"
              v-model="l.i1"
            >
              <Option
                v-for="(f, fi) in flags"
                :key="fi"
                :value="f.id"
                :label="f.title"
              ></Option>
            </Select>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <b-pagination
        size="sm"
        align="center"
        v-model="pager.current"
        :total-rows="tasksCount"
        :per-page="pager.perPage"
        @change="pageChanged"
        style="margin-bottom: 0"
        ></b-pagination> -->
  </div>
</template>

<script>
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Select, Option } from "element-ui";

export default {
  components: {
    Select,
    Option
  },
  props: {
    propId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      srchVal: "",
      tasksCount: 0,
      pager: {
        current: 0,
        perPage: 30
      },
      list: [],
      listAll: [],
      flags: [
        { id: 1, title: "Ирсэн" },
        { id: 2, title: "Чөлөөтэй" },
        { id: 3, title: "Өвчтэй" },
        { id: 4, title: "Тас" }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      request({
        api: { method: "GET", url: "TaskInUser/GetInheritedNotDynamicList" },
        params: { taskId: this.propId, page: 0, size: 1 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.listAll = res.data.users;
          this.list = res.data.users;
        }
      });
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    i1Changed(uid, e) {
      request({
        api: { method: "POST", url: "v2/Learn/setLessonAttendance" },
        data: { taskId: this.propId, userId: uid, i1: e },
        store: this.$store
      }).then(res => {
        if (res != false) {
        }
      });
    },
    doFilter() {
      let _un = this.srchVal.toLowerCase();
      this.list = this.listAll.filter(u => {
        return (
          u.displayName != null && u.displayName.toLowerCase().indexOf(_un) > -1
        );
      });
    }
  }
};
</script>

<style></style>
